// 'btt-ecosystem' = BTT brand landing page (/btt-ecosystem/). Its i18n is handled by an in-page
// EN/中文 dictionary (no URL-based locales), so we keep it out of the 17-locale
// generation and only emit the English route.
const unlocalizedPages = ['blog', 'sr', 'legal', 'btt-ecosystem', 'btt'];

const regexFirstPathElement = /^\/([^/]*)/;
const regexHelpCenterSupportPage = /^\/en\/support\//;

function getFirstPathElement(path) {
    return path.match(regexFirstPathElement)[1];
}

function unlocalizedPageCheck(path) {
    if (!path || path.includes('/blog/pressroom')) {
        return true;
    }

    if (regexHelpCenterSupportPage.test(path)) {
        return true;
    }

    let firstPathEl = getFirstPathElement(path);

    return unlocalizedPages.includes(firstPathEl);
}

exports.unlocalizedPages = unlocalizedPages;
exports.regexFirstPathElement = regexFirstPathElement;
exports.regexHelpCenterSupportPage = regexHelpCenterSupportPage;
exports.getFirstPathElement = getFirstPathElement;
exports.unlocalizedPageCheck = unlocalizedPageCheck;
